export class AddToGalleryModel {
    public galleryId: string;
    public contestSubmissionId: number;
}



// WEBPACK FOOTER //
// ./src/models/gallery/add.to.gallery.model.ts